export default "__VITE_ASSET__Cw2HA0qE__"